export default "__VITE_ASSET__B5q__D9L__"